import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid pt-3" }
const _hoisted_2 = { class: "field pb-2" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = { class: "field" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = { class: "grid justify-content-end center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Confirm", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Cancel", -1)

import firebaseApp from "@/utilities/firebase/firebase"
import { getAuth, signInWithEmailAndPassword } from "firebase/auth"
import { withDefaults, computed, ref, reactive } from "vue"
import { required } from "@vuelidate/validators"
import useVuelidate from "@vuelidate/core"
import { FirebaseError } from "firebase/app"
import { useToast } from "primevue/usetoast"
import { useRouter } from "vue-router"
import { RouteNames } from "@/router"

/* Props */
interface propsInterface {
	isOpen?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginModal',
  props: {
    isOpen: { type: Boolean, default: false }
  },
  emits: ["change-open-state"],
  setup(__props: any, { emit }: { emit: ({
	(event: "change-open-state", isOpen: boolean): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isOpen: boolean };






/* Properties */
const toast = useToast()
const auth = getAuth(firebaseApp)
const router = useRouter()


const isVisible = computed({
	get() {
		return props.isOpen
	},
	set(value: boolean) {
		emit("change-open-state", value)
	}
})

const loginForm = reactive({
	email: "",
	password: "",
})
const rules = {
	email: { required },
	password: { required },
}
const validation = useVuelidate(rules, loginForm)
const hasBeenSubmitted = ref(false)

/* Methods */
async function login() {
	hasBeenSubmitted.value = true
	validation.value.$validate()

	if (validation.value.$errors.length > 0) {
		return toast.add({ severity: "error", summary: "Form error", detail: "Please correct the invalid fields", life: 3000 })
	}

	const userCredentials = await signInWithEmailAndPassword(auth, loginForm.email, loginForm.password)
		.catch((error: FirebaseError) => {
			console.error("There was an error logging in: " + error)
			return error
		})

	if (userCredentials instanceof FirebaseError) {
		console.warn("code: " + userCredentials.code + "message: " + userCredentials.message + "name: " + userCredentials.name + "customData: " + userCredentials.customData)
		if (userCredentials.code == "auth/invalid-email") {
			return toast.add({ severity: "error", summary: "Invalid login credentials", detail: "The email and password do not match an existing user." })
		}

		return toast.add({ severity: "error", summary: "Error logging in", detail: `${userCredentials.code}` })
	}

	console.log("Successfully signed in: " + userCredentials.user.email)
	changeOpenState(false)
}

function openSettingsPage() {
	changeOpenState(false)
	router.push(RouteNames.Settings)
}

function changeOpenState(isOpen: boolean) {
	isVisible.value = isOpen
}


return (_ctx: any,_cache: any) => {
  const _component_p_input_text = _resolveComponent("p-input-text")!
  const _component_fa = _resolveComponent("fa")!
  const _component_p_button = _resolveComponent("p-button")!
  const _component_p_dialog = _resolveComponent("p-dialog")!

  return (_openBlock(), _createBlock(_component_p_dialog, {
    header: "Login",
    visible: __props.isOpen,
    "onUpdate:visible": changeOpenState,
    position: "top",
    displayPosition: true,
    modal: true,
    dismissableMask: true,
    draggable: false,
    closable: true,
    "auto-z-index": true,
    "base-z-index": 100,
    breakpoints: { '1080px': '75vw', '640px': '100vw' },
    class: "container-modal"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_p_button, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (login())),
        class: "p-button-primary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_fa, {
            icon: ['fas', 'check'],
            size: "1x"
          }),
          _hoisted_9
        ]),
        _: 1
      }),
      _createVNode(_component_p_button, {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (isVisible.value = false)),
        class: "p-button-text"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_fa, {
            icon: ['fas', 'times'],
            size: "1x"
          }),
          _hoisted_10
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("article", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_p_input_text, {
              id: "loginEmail",
              modelValue: _unref(validation).email.$model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(validation).email.$model) = $event)),
              type: "email",
              autofocus: "",
              class: _normalizeClass({ 'p-invalid': _unref(validation).email.$invalid && hasBeenSubmitted.value })
            }, null, 8, ["modelValue", "class"]),
            _createElementVNode("label", {
              for: "loginEmail",
              class: _normalizeClass({ 'p-error': _unref(validation).email.$invalid && hasBeenSubmitted.value })
            }, "Email", 2)
          ]),
          (_unref(validation).email.$invalid && hasBeenSubmitted.value)
            ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_unref(validation).email.required.$message.replace('Value', 'Email')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_p_input_text, {
              id: "loginPassword",
              modelValue: _unref(validation).password.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(validation).password.$model) = $event)),
              type: "password",
              autofocus: "",
              class: _normalizeClass({ 'p-invalid': _unref(validation).password.$invalid && hasBeenSubmitted.value })
            }, null, 8, ["modelValue", "class"]),
            _createElementVNode("label", {
              for: "loginPassword",
              class: _normalizeClass({ 'p-error': _unref(validation).password.$invalid && hasBeenSubmitted.value })
            }, "Password", 2)
          ]),
          ((_unref(validation).password.$invalid || _unref(validation).password.$pending) && hasBeenSubmitted.value)
            ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_unref(validation).password.required.$message.replace('Value', 'Password')), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_fa, {
          icon: ['fas', 'question-circle'],
          class: "text--mini"
        }),
        _createVNode(_component_p_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (openSettingsPage())),
          label: "Help, I forgot my password.",
          class: "p-button-link p-button-sm text--mini"
        })
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})